import { http } from './http';
import {
  SubscriptionContext,
  SubscriptionCheckoutResponse,
  SubscriptionPortalResponse,
} from '../types';

export interface SessionStatusResponse {
  status: 'complete' | 'expired' | 'open';
  paymentStatus: 'paid' | 'unpaid' | 'no_payment_required';
  customerEmail: string | null;
}

export const billingApi = {
  async fetchSubscriptionContext(): Promise<SubscriptionContext> {
    const { data } = await http.get<SubscriptionContext>(
      '/v1/billing/subscription/context',
    );
    return data;
  },

  async createCheckoutSession(payload: {
    priceId: string;
    successUrl?: string;
    promoCode?: string;
  }): Promise<SubscriptionCheckoutResponse> {
    const { data } = await http.post<SubscriptionCheckoutResponse>(
      '/v1/billing/subscription/checkout',
      payload,
    );
    return data;
  },

  async validatePromoCode(code: string): Promise<{
    valid: boolean;
    promotionCodeId?: string;
    description?: string;
    percentOff?: number;
    amountOff?: number;
    currency?: string;
  }> {
    const { data } = await http.get('/v1/billing/subscription/validate-promo', {
      params: { code },
    });
    return data;
  },

  async createPortalSession(payload?: {
    returnUrl?: string;
  }): Promise<SubscriptionPortalResponse> {
    const { data } = await http.post<SubscriptionPortalResponse>(
      '/v1/billing/subscription/portal',
      payload ?? {},
    );
    return data;
  },

  async getSessionStatus(sessionId: string): Promise<SessionStatusResponse> {
    const { data } = await http.get<SessionStatusResponse>(
      `/v1/billing/subscription/session-status?session_id=${encodeURIComponent(sessionId)}`,
    );
    return data;
  },

  async upgradeSubscription(priceId: string): Promise<{ subscriptionId: string; status: string; requiresPayment: boolean; invoiceUrl: string | null }> {
    const { data } = await http.post('/v1/billing/subscription/upgrade', { priceId });
    return data;
  },

  async cancelSubscription(): Promise<{ subscriptionId: string; cancelAtPeriodEnd: boolean; cancelAt: string | null }> {
    const { data } = await http.post('/v1/billing/subscription/cancel', {});
    return data;
  },

  async reactivateSubscription(): Promise<{ subscriptionId: string; cancelAtPeriodEnd: boolean }> {
    const { data } = await http.post('/v1/billing/subscription/reactivate', {});
    return data;
  },
};
